/**
 * @desc: - 投注选号 - 大小单双
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} title:        [标题]
 * @param  {[STRING]} items:        [选项: 多个选项由单竖线隔开 0|2|3 ]
 * @param  {[STRING]} values:       [当前选中值 ]
 * @param  {[BOOLEN]} showButton:   [是否需要快捷选择按钮 ]
 * @param  {[NUMBER]} index:        [当前行 ]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: ammo
 */
export default class BetDxDs extends React.Component {

	constructor(props) {
		super(props);
    this.makeDisplay = this.makeDisplay.bind(this)
	}

	// 点击
	handleClick(selectValue){
    const {items, values, onChange, index} = this.props;
    const arrayList = items.split('|');
    let result = null;
    switch (selectValue){
      // 全选
      case 'all': {
        result = arrayList;
        break;
      }
      // 清空
      case 'clear': {
        result = [];
        break;
      }
    }
    // 点击选择区
    if (!result) {
      // 已选
      if(selectValue.checked){
        result = _.remove(values, function(n){
          return n != selectValue.display
        })
      }else{
        // 没有选
        result = _.sortBy(_.concat(values, selectValue.display))
      }
    }
    onChange(result, index);
	}

	// 组装显示结果
	makeDisplay(items, values){
    const displayList = [];
    _.forEach(items.split('|'), function(item){
      let eachItem = {
        display: item,
        checked: _.includes(values, item)
      }
      displayList.push(eachItem);
    })
    return displayList
	}

	render() {
		const {className, title, items, values, showButton} = this.props;
    const displayList = this.makeDisplay(items, values);
		return (
			<div className="each">
        {
          title ? <h4>{title}</h4> : null
        }
				<ul className='nList'>
					{
						displayList.map((item, index) => {
							return <li 
                      key={index} 
                      onClick={this.handleClick.bind(this, item)} 
                      className={item.checked ? 'hover' : ''} >
                      {item.display}</li>
						})
					}
				</ul>
        <ul className='cList'>
          <li onClick={this.handleClick.bind(this, 'all')} >全</li>
          <li onClick={this.handleClick.bind(this, 'clear')} >清</li>
        </ul>
			</div>
		);
	}
}
